import React from "react";
import { Base64 } from "js-base64";
import { SelectNew, Checkbox, Radio, Icon, Dropdown } from "antd";
import "./style/index.less";
import classNames from "classnames";
import isString from "lodash/isString";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import isArray from "lodash/isArray";
import xor from "lodash/xor";
import find from "lodash/find";
import toString from "lodash/toString";
import WeaTools from "../wea-tools";
import WeaCheckbox from "../wea-checkbox";
import WeaHelpfulTip from "../wea-helpful-tip";
import uniq from "lodash/uniq";
import isFunction from "lodash/isFunction";
import uniqueId from "lodash/uniqueId";
import WeaLocaleProvider from "../wea-locale-provider";
import WindowFunc from "../wea-tools/window";
import middleware from "../../middleware";

const { getLabel, formatMultiLang } = WeaLocaleProvider;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;

const Option = SelectNew.Option;
const OptGroup = SelectNew.OptGroup;

const getDefault = props => {
  if (props.value != undefined && props.value !== "") return props.value;
  return WeaTools.getSelectDefaultValue(props.options);
};
class main extends React.Component {
  static defaultProps = {
    widthMatchOptions: false, // select 框的宽度匹配options 的宽度
    dropdownMatchSelectWidth: false,
    hasAddBtn: false //显示加号按钮
  };
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      value: getDefault(props), // id,id,id
      optionMaxWidth: 2000,
      dropdownStyle: props.dropdownStyle || {} // 下拉框样式
    };
    if (
      props.detailtype == 1 &&
      !props.multiple &&
      !isEmpty(props.options) &&
      props.value
    ) {
      let values = [];
      if (typeof props.value != "string") {
        if (typeof props.value == "number") {
          values = [props.value];
        } else {
          values = props.value;
        }
      } else {
        values = props.value.split(",");
      }
      if (
        props.options.filter(o => o.key == values[values.length - 1]).length ==
        0
      ) {
        this.state.value = "";
        isFunction(this.props.onChange) && this.props.onChange("");
      }
    }
    this.setValue = this.setValue.bind(this);
    this.onAllChange = this.onAllChange.bind(this);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.addOnClick = this.addOnClick.bind(this);
    this.index = uniqueId("weaSelect_");
  }
  componentDidMount() {
    const { widthMatchOptions, options } = this.props;
    const parentWidth = $(this.refs.wrapper)
      .parent()
      .outerWidth();
    if (parentWidth) {
      // 下拉框的宽度限定最大最小宽度（在200-700之间自适应）
      const maxWidth =
        parentWidth > 700 || parentWidth < 200 ? 700 : parentWidth;
      const dropStyle = this.state.dropdownStyle; // props.dropdownStyle 可以覆盖当前的值
      this.setState({
        dropdownStyle: { maxWidth, ...dropStyle }
      });
    }
    if (widthMatchOptions) {
      let minWidth = this.getOptionsWidth(options);

      this.setState({ minWidth, maxWidth: parentWidth });
    }
    const optionMaxWidth = document.getElementById(this.index)
      ? document.getElementById(this.index).clientWidth
      : 2000;
    this.setState({ optionMaxWidth });
  }
  componentWillReceiveProps(nextProps) {
    if ("value" in nextProps && this.state.value != nextProps.value) {
      let v = nextProps.value || "";
      const { options } = nextProps;
      if (
        nextProps.detailtype == 1 &&
        !nextProps.multiple &&
        !isEmpty(options)
      ) {
        if (options.filter(o => o.key == v).length == 0) {
          v = "";
          if (v != this.props.value)
            isFunction(this.props.onChange) && this.props.onChange(v);
        }
      }
      this.setState({ value: v });
    }
    if (
      "options" in nextProps &&
      this.props.widthMatchOptions &&
      !isEqual(nextProps.options, this.props.options)
    ) {
      this.setState({ minWidth: this.getOptionsWidth(nextProps.options) });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.value != this.props.value ||
      nextProps.viewAttr != this.props.viewAttr ||
      nextProps.underline != this.props.underline ||
      nextProps.hasBorder != this.props.hasBorder ||
      nextState.value != this.state.value ||
      nextState.visible != this.state.visible ||
      nextState.minWidth != this.state.minWidth ||
      !isEqual(nextProps.options, this.props.options) ||
      nextProps.fieldName != this.props.fieldName ||
      nextState.optionMaxWidth != this.state.optionMaxWidth ||
      nextProps.detailtype != this.props.detailtype ||
      nextProps.disabled != this.props.disabled
    );
  }
  addOnClick() {
    this.props.addOnClick && this.props.addOnClick();
  }
  setValue(value) {
    if (typeof value === "object" && "target" in value) {
      value = value.target.value == this.state.value ? "" : value.target.value;
    }
    let xorKey = "";
    if (isArray(value)) {
      xorKey = xor(value, this.state.value.split(","));
    }
    this.setState({ value: `${value}` });
    let showname = "";
    let key = "";
    const item =
      this.props.options &&
      this.props.options.filter(data => {
        if (isArray(value)) {
          for (let index = 0; index < value.length; index++) {
            return data.key == value[index];
          }
        } else {
          return data.key == value;
        }
      });
    if (item && item.length > 0) {
      if (isArray(value)) {
        this.props.options &&
          this.props.options.forEach(data => {
            for (let index = 0; index < value.length; index++) {
              if (data.key == value[index]) {
                showname += data.showname + ",";
                key += data.key + ",";
              }
            }
          });

        showname = showname.substring(0, showname.length - 1);
        key = key.substring(0, key.length - 1);
      } else {
        showname = item[0].showname;
        key = item[0].key;
      }
    } else {
      key = xorKey;
    }
    typeof this.props.onChange === "function" &&
      this.props.onChange(`${value}`, this.formatBase64(showname), key);
  }
  getOptionsWidth(options) {
    let minWidth = 40;
    if (!isEmpty(options)) {
      options.forEach(o => {
        let textWidth = WeaTools.getTextWidth(o.showname) + 35;
        minWidth = textWidth > minWidth ? textWidth : minWidth;
      });
    }
    const parentWidth = $(this.refs.wrapper)
      .parent()
      .outerWidth();
    if (parentWidth && parentWidth - 20 < minWidth) minWidth = parentWidth - 20;
    return minWidth;
  }
  isReadOnly() {
    const { viewAttr } = this.props;
    return viewAttr == 1;
  }
  onAllChange(v) {
    const { props } = this;
    let values = [],
      shownames = [];
    if (v == 1) {
      props.options.forEach(o => {
        values.push(o.key);
        shownames.push(o.showname);
      });
    }
    this.setState({ value: values.join(",") });
    isFunction(props.onChange) &&
      props.onChange(values.join(","), shownames.join(","));
  }
  onItemChange(v, id) {
    const { props } = this;
    let { value = "" } = this.state;
    let values = value ? value.split(",") : [],
      shownames = [];
    if (v == "1") {
      values.push(id);
    } else {
      values = values.filter(val => val != id);
    }
    values.forEach(val => {
      let target = find(props.options || [], { key: val });
      if (target) shownames.push(target.showname);
    });
    this.setState({ value: values.join(",") });
    isFunction(props.onChange) &&
      props.onChange(values.join(","), shownames.join(","));
  }
  isAllChecked() {
    const { options } = this.props;
    const { value } = this.state;
    let v = "0";
    const values = value.split(",");
    if (value && uniq(values).length === options.length) v = "1";
    return v;
  }
  isChecked(v) {
    const { value = "" } = this.state;
    const array = value.split(",");
    return array.indexOf(v) > -1 ? "1" : "0";
  }
  getShownames() {
    const { options } = this.props;
    let { value = "" } = this.state;
    let values = value.split(","),
      shownames = [];
    values.forEach(val => {
      let target = options.filter(data => data.key == val)[0];
      if (target) shownames.push(target.showname);
    });
    return shownames.join(",");
  }
  handleVisibleChange(visible) {
    this.setState({ visible });
  }
  getList() {
    const { options } = this.props;
    const { dropdownStyle = {} } = this.state;
    let style = {};
    // if (options.length > 5) {
    style = {
      maxHeight: 200,
      overflowY: "auto",
      overflowX: "hidden",
      ...dropdownStyle
    };
    // }
    return (
      <div className="wea-select-panel" style={style}>
        <div className="wea-select-panel-item">
          <WeaCheckbox
            content={getLabel(556, "全选")}
            value={this.isAllChecked()}
            onChange={this.onAllChange}
          />
        </div>
        {options &&
          options.map(o => {
            return (
              <div className="wea-select-panel-item">
                <WeaCheckbox
                  content={o.showname}
                  value={this.isChecked(o.key)}
                  onChange={v => this.onItemChange(v, o.key)}
                />
              </div>
            );
          })}
      </div>
    );
  }

  onSelect(v) {
    const { props, state } = this;
    if (state.value == v && props.canSelectRepeat) {
      this.setValue(v);
    }
  }

  formatBase64(value) {
    if (typeof value === "string" && value.includes("base64_")) {
      value = Base64.decode(value.substr(7));
    }
    return value;
  }

  render() {
    let {
      underline,
      options: _options,
      layout,
      style,
      detailtype = 1,
      fieldshowtypes,
      viewAttr,
      fieldName,
      hasBorder,
      widthMatchOptions,
      textDecoration,
      hasAddBtn,
      multiple,
      disabled,
      helpfulTip,
      helpfulTipProps,
      isDetail
    } = this.props;
    let { value } = this.state;
    //detailtype 1: 正常显示,2:checkbox 多选,3:radio 单选
    const verticalStyle = fieldshowtypes == 2 ? { display: "block" } : {};
    const options = _options
      ? _options.map(o => ({
          ...o,
          showname: formatMultiLang(this.formatBase64(o.showname))
        }))
      : [];
    if (detailtype == 4 && viewAttr == "1") {
      return (
        <div className={`wea-select ${this.props.className}`} style={style}>
          {" "}
          <span className="wea-select-list">
            {options &&
              options.map(data => {
                return (
                  <span className="wea-select-list-item" title={data.showname}>
                    {data.showname}
                  </span>
                );
              })}
          </span>
        </div>
      );
    }
    if (this.isReadOnly() && detailtype != 2 && detailtype != 3) {
      const readonly = classNames({
        border: hasBorder,
        underline: underline
      });
      let v = [];
      if (value != null) v = toString(value).split(",");
      return (
        <span
          className={`wea-field-readonly ${readonly} wea-select ${this.props.className}`}
          style={style}
        >
          {!isEmpty(v) &&
            !isEmpty(options) &&
            options.map(o => {
              if (v.indexOf(o.key) > -1) {
                return <span className="child-item wdb">{o.showname}</span>;
              }
            })}
          <span className="icon-coms-down2 wea-select-arrow" />
          {helpfulTip && (
            <WeaHelpfulTip
              style={{ position: "absolute", right: -31, top: 4 }}
              title={helpfulTip}
              {...helpfulTipProps}
            />
          )}
          <input type="hidden" id={fieldName} name={fieldName} value={value} />
        </span>
      );
    }
    if (this.isReadOnly() && (detailtype == 2 || detailtype == 3)) {
      disabled = true;
    }
    let objArr = [];
    if (!isEmpty(options)) {
      objArr = options.map(o => {
        const obj = { ...o };
        obj.style = verticalStyle;
        obj.label = <span title={o.showname}>{o.showname}</span>;
        obj.value = o.value || o.key;
        if (disabled) obj.disabled = true;
        return obj;
      });
      objArr = objArr.filter(o => o.value != "");
    }
    const selectStyle = {};
    if (widthMatchOptions) {
      if (selectStyle.minWidth) delete selectStyle.minWidth;
      selectStyle.minWidth = this.state.minWidth;
      selectStyle.maxWidth = this.state.maxWidth - 3;
    }
    const cls = classNames({
      mr15: /^field/.test(fieldName) || (viewAttr == "3" && value.length == 0),
      "wea-field": /^field/.test(fieldName),
      pr15: viewAttr == "3" && isDetail /** 明细表中必填项 */
    });
    const req = classNames({
      required: viewAttr == "3" && this.state.value.length == 0
    });
    if (!isEmpty(options) && detailtype == 1) {
      if (isEmpty(options.filter(o => o.value == value || o.key == value)))
        value = "";
    }
    let sStyle = { ...style } || {};
    if (multiple) detailtype = 100;
    let selectClassName = "";
    let dropdownClassName = "wea-select-dropdown";
    if (this.props.selectClassName) {
      selectClassName += " " + this.props.selectClassName + " ";
    }
    if (textDecoration) {
      selectClassName += " text-decoration ";
    }
    if (this.props.dropdownClassName) {
      dropdownClassName += " " + this.props.dropdownClassName + " ";
    }
    let emptyStr = this.props.notFoundContent || " ";
    return (
      <div
        className={`wea-select ${cls} ${this.props.className || ""}`}
        id={this.index}
        style={sStyle}
        ref="wrapper"
      >
        {detailtype == 1 && (
          <SelectNew
            {...this.props}
            onSelect={v => this.onSelect(v)}
            className={selectClassName}
            dropdownClassName={dropdownClassName}
            ref="select"
            size={"default"}
            style={selectStyle}
            dropdownStyle={this.state.dropdownStyle}
            getPopupContainer={() => {
              if (this.props.useSelfLayout) {
                return ReactDOM.findDOMNode(this.refs.wrapper);
              } else {
                return layout || WindowFunc.getTop().document.body;
              }
            }}
            value={value}
            animation=""
            notFoundContent={emptyStr}
            onChange={this.setValue}
          >
            {options &&
              options.map(data => {
                return (
                  <Option
                    disabled={data.disabled}
                    className={data.className}
                    key={data.key}
                    value={data.key}
                    title={data.shownameText || data.showname}
                  >
                    {data.showname}
                  </Option>
                );
              })}
          </SelectNew>
        )}
        {detailtype == 5 && (
          <SelectNew
            {...this.props}
            className={textDecoration ? "text-decoration" : ""}
            dropdownClassName={"wea-select-dropdown"}
            ref="select"
            size={"default"}
            style={selectStyle}
            dropdownStyle={this.state.dropdownStyle}
            getPopupContainer={() => layout || document.body}
            value={value}
            animation=""
            onChange={this.setValue}
          >
            {options &&
              options.map(data => {
                return (
                  <OptGroup key={data.key || data.label} label={data.label}>
                    {data.options &&
                      data.options.map(data => {
                        return (
                          <Option
                            disabled={data.disabled}
                            className={data.className}
                            key={data.key}
                            value={data.key}
                            title={data.shownameText || data.showname}
                          >
                            {data.showname}
                          </Option>
                        );
                      })}
                  </OptGroup>
                );
              })}
          </SelectNew>
        )}
        {detailtype == 2 && (
          <CheckboxGroup
            disabled={disabled}
            options={objArr}
            value={value ? value.split(",") : []}
            onChange={this.setValue}
          />
        )}
        {detailtype == 3 && (
          <RadioGroup
            disabled={disabled}
            value={value}
            onChange={this.setValue}
          >
            {objArr.map(data => {
              return (
                <Radio
                  style={data.style}
                  disabled={data.disabled || disabled}
                  key={data.key}
                  value={data.key}
                  title={isString(data.showname) ? data.showname : ""}
                  checked={data.key == value}
                  onClick={() => {
                    if (this.props.supportCancel && data.key == value) {
                      this.setState({ value: "" });
                      typeof this.props.onChange === "function" &&
                        this.props.onChange("", "");
                    }
                  }}
                >
                  {data.showname}
                </Radio>
              );
            })}
          </RadioGroup>
        )}
        {detailtype == 4 && (
          <span className="wea-select-list">
            {options &&
              options.map(data => {
                return (
                  <span
                    className={`wea-select-list-item cursor-pointer ${
                      data.key == value ? "active" : ""
                    }`}
                    onClick={this.setValue.bind(this, data.key)}
                    key={data.key}
                    title={data.showname}
                  >
                    {data.showname}
                  </span>
                );
              })}
          </span>
        )}
        {detailtype == 100 && (
          <Dropdown
            trigger={["click"]}
            overlay={this.getList()}
            onVisibleChange={this.handleVisibleChange}
            visible={this.state.visible}
            getPopupContainer={() => layout || document.body}
          >
            <div
              className="wea-select-input wdb cursor-pointer"
              ref="selectInput"
            >
              <span>{this.getShownames()}</span>
              {!this.state.visible ? (
                <i className="icon-coms-down2 arrow" />
              ) : (
                <i className="icon-coms-up2 arrow" />
              )}
            </div>
          </Dropdown>
        )}
        {hasAddBtn && (
          <span
            className="add-icon-wrapper cursor-pointer"
            onClick={this.addOnClick}
          >
            <Icon className="add-icon" type="plus" />
          </span>
        )}
        {viewAttr == "3" && this.state.value.length == 0 && (
          <span className={`wea-required-e9 ${hasAddBtn ? "hasAddBtn" : ""}`}>
            <img src="/images/BacoError_wev9.png" align="middle" />
          </span>
        )}
        {helpfulTip && (
          <WeaHelpfulTip
            style={{ position: "absolute", right: -31, top: 4 }}
            title={helpfulTip}
            {...helpfulTipProps}
          />
        )}
        <input type="hidden" name={fieldName} id={fieldName} value={value} />
      </div>
    );
  }
}

const Com = middleware(main, "WeaSelect");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-select/index.js